export const ELITE_SECTION_NAMES = {
    ELITE_CAR_REG_NO: "ELITE_CAR_REG_NO",
    ELITE_CAR_BRANDS: "ELITE_CAR_BRANDS",
    ELITE_CAR_REG_NO_TITLE: "ELITE_CAR_REG_NO_TITLE",
    ELITE_LANDING_PAGE_TOP: "ELITE_LANDING_PAGE_TOP",
    WHY_CHOOSE_ELITE: "WHY_CHOOSE_ELITE",
    ELITE_HOW_IT_WORKS: "ELITE_HOW_IT_WORKS",
    ELITE_STORES: "ELITE_STORES",
    ELITE_RECENTLY_SOLD: "ELITE_RECENTLY_SOLD",
    ELITE_NUMBERS: "ELITE_NUMBERS",
    ELITE_USER_EXPERIENCE: "ELITE_USER_EXP",
    ELITE_FAQ: "ELITE_FAQ",
    ELITE_GET_BEST_PRICE: "ELITE_GET_BEST_PRICE",
    ELITE_LANDING_PAGE_DSTP: "ELITE_LANDING_PAGE_DSTP",
    WHY_CHOOSE_ELITE_MOBILE: "WHY_CHOOSE_ELITE_MWEB"
};
